import { Button, Form, Row, Space, Typography } from "antd";
import { resetPassword } from "aws-amplify/auth";
import type { FC, MouseEventHandler } from "react";
import { useState } from "react";
import { useInterval } from "react-use";
import { FormInput } from "ui/form";

const { Link, Text } = Typography;

interface VerifyAccountForm {
  email: string;
  code: string;
}
export const VerifyAccount: FC = () => {
  const [form] = Form.useForm<VerifyAccountForm>();

  const [isSent, setIsSent] = useState(false);
  const [countDown, setCountDown] = useState(60);

  useInterval(() => {
    if (isSent) {
      if (countDown > 0) {
        setCountDown((prev) => prev - 1);
      } else {
        setCountDown(60);
        setIsSent(false);
      }
    }
  }, 1000);

  const sendCode: MouseEventHandler = async (event) => {
    event.stopPropagation();
    form.validateFields(["email"], { validateOnly: true });
    const username = form.getFieldValue("email");
    resetPassword({ username });
    setIsSent(true);
  };

  const onNext = async () => {
    form.submit();
  };

  return (
    <Form form={form} labelCol={{ span: 6 }} labelWrap name="verify">
      <FormInput label="メールアドレス" maxLength={128} name="email" rules={[{ required: true }, { type: "email" }]} />
      <FormInput
        label="確認コード"
        name="code"
        onChange={(event) => form.setFieldValue("code", event.target.value.replace(/\D/g, ""))}
        rules={[{ required: true, min: 6, max: 6 }]}
        suffix={
          <>
            {!isSent && <Link onClick={sendCode}>確認コードを送信</Link>}
            {isSent && <Text>重新发送({countDown}s)</Text>}
          </>
        }
      />
      <Row justify="center">
        <Space>
          <Button onClick={onNext} type="primary">
            次へ
          </Button>
        </Space>
      </Row>
    </Form>
  );
};
